import Jsona from 'jsona';
const dataFormatter = new Jsona();

export { dataFormatter };
